import { openTimePanel, isTimePanelAvailable } from 'owa-time-panel-bootstrap';
import { isPanelOpen } from '../selectors/timePanelStoreSelectors';
import { orchestrator } from 'satcheljs';
import { openTimePanelInternal } from '../actions/timePanelStoreActions';
import { toggleTimePanel } from '../utils/toggleTimePanel';

export const openTimePanelOrchestrator = orchestrator(openTimePanel, actionMessage => {
    // sanity check for feature availability
    if (!isTimePanelAvailable()) {
        return;
    }

    openTimePanelInternal(actionMessage.source);

    // noop if panel is already open
    if (isPanelOpen()) {
        return;
    }

    toggleTimePanel();
});
